import React, { createContext, useContext, useState } from 'react';
import RightSideBar from './rightSidebar';

const RightSidebarContext = createContext();

export function RightSidebarProvider({ children, width }) {
    const [open, setOpen] = useState(false);
    const [sidebarWidth, setSidebarWidth] = useState('500px');
    const [contentData, setContentData] = useState(null);

    const showRightSidebar = (contentData, width) => {
        setOpen(true);
        setContentData(contentData);
        setSidebarWidth(width)
    };

    const handleContent = () => {
        return contentData.content(contentData.data);
    }

    const handleCloseRightSidebar = () => {
        setOpen(false);
        setContentData(null);
    }

    return (
        <RightSidebarContext.Provider value={{ showRightSidebar, handleCloseRightSidebar }}>
            {children}
            {open && <RightSideBar  {...{ handleContent, open, handleCloseRightSidebar, sidebarWidth }} />}
        </RightSidebarContext.Provider>
    );
}

export function useRightSidebar() {
    return useContext(RightSidebarContext);
}
